<template>
  <div class="row m-h-desktop" id="about">
    <div class="col-12">
      <div class="about__box">
        <h2 class="about__headline">
          Na czym polega akcja Adoptuj Pszczołę?
        </h2>
        <div class="about__content">
         Adoptuj Pszczołę to akcja społeczna Greenpeace, dzięki której już dziewiąty rok tysiące osób wspólnie angażują się w pomaganie pszczołom, a Polska staje się coraz bardziej przyjazna zapylaczom. Dzięki „adopcjom” wirtualnych pszczół każdy ma szansę pomóc owadom zapylającym. Wspólnie budujemy Polskę przyjazną zapylaczom!
          <br />
          <br />
          Dziewiąta  edycja Adoptuj Pszczołę jest kontynuacją naszych wspólnych działań, które sprawią, że Polska będzie krajem prawdziwie przyjaznym zapylaczom. Jak zawsze chcemy odpowiedzieć na potrzeby wszystkich owadów zapylających, ale szczególną uwagę poświęcimy zapylaczom żyjącym w lasach. O tym, dlaczego leśne zapylacze potrzebują Twojej pomocy, przeczytasz tutaj:
        </div>
        <div>
          <router-link class="about__btn" to="/pytania-i-odpowiedzi/dlaczego-lesne-zapylacze-potrzebują-naszej-pomocy">
            O leśnych zapylaczach
            <font-awesome-icon :icon="['fas', 'angle-double-right']" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      title: "about",
    };
  },
};
</script>
